export default [
  // Centers
  {
    path: "/05097b37cac61faad9e752b8",
    children: [
      {
        path: "sDPI062662dee434215938291ea3HF48",
        name: "qe26.centers",
        meta: {
          title: "QE 2026 centers",
          authRequired: true,
          acc: ["y45891"],
        },
        component: () => import("@/views/qe/tws/center_management/index.vue"),
      },
      // view center
      {
        path: "kUDP05613e498c62e835e919f7b0qTla/:cn?",
        name: "qe26.center.view",
        meta: {
          title: "View QE 2026 center",
          authRequired: true,
          acc: ["y76118"],
        },
        component: () => import("@/views/qe/tws/center_management/view.vue"),
      },
        // assign center
       {
        path: "w2c05a96c33c790578ca55cc2413f",
        name: "qe26.center.create",
        meta: {
          title: "Create QE 2026 center",
          authRequired: true,
          acc: ["y19106"],
        },
        component: () => import("@/views/qe/tws/center_management/create.vue"),
      },
      //   {
      //     path: "hgnerugervbhoiuvervgye",
      //     name: "newCenters",
      //     meta: {
      //       title: "2025 QE NEW CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/newCenters.vue"),
      //   },
      //   {
      //     path: "center_requests",
      //     name: "newCenterRequest",
      //     meta: {
      //       title: "2025 QE NEW CENTERS Requests",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/requests.vue"),
      //   },
      //   {
      //     path: "center_request/:cn?",
      //     name: "CenterRequestv",
      //     meta: {
      //       title: "2025 QE Requests Details",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/request.vue"),
      //   },
      //   {
      //     path: ":cn/edit_center",
      //     name: "editCenter",
      //     meta: {
      //       title: "EDIT CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/qe/twf/center_management/edit-center.vue"),
      //   },
    ],
  },
];
